<template>
<div>
    <button @click="getItems" class="btn btn-sm btn-success mb-3">Обновить</button>
    <ul v-if="item">
         <li v-for="(i,k) in features" :key="k">
              <h4>{{i.id}} # {{i.title}}</h4>
              <ul v-if="i.childs.length">
                  <li v-for="feature in i.childs" :key="feature.id">
                      <h6>{{feature.id}} # {{feature.title}}</h6>
                      <tags :feature_id="feature.id"  v-model="values[`feature_${feature.id}`]" />       
                  </li>
              </ul>
          </li>
    </ul>
      <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  props: ["id"],
  data: () => ({
    item:null,
    cardLink:'warehouse/options',
    values:{}
  }),
   created(){
     this.getItems();
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async getItems(){
      this.item = null;
      this.item = await this.cardContent(this.cardLink, this.id);
    },
     updateItem() {
      this.$loading(true);
      this.$http({ url: `${this.cardLink}/${this.id}`,
                  method: 'PUT',
                  data: {values:this.values, is_feature:true}
            }).then(response => {
                console.log(response.data);
            }).finally(()=>{
               this.$loading(false);
            });
    },
  },
  computed:{
    features:{
          get(){
              let features =  this.item.product.name.features;
              if (!Array.isArray(this.item.values)){
                    this.values = this.item.values;
              }
              for(let i=0;i<features.length;i++){
                for(let j = 0; j<features[i].childs.length;j++){
                    if(!this.values[`feature_${features[i].childs[j].id}`]){
                      this.values[`feature_${features[i].childs[j].id}`] = [];
                    }
                }
              }
              return  features;
          }
    }
  }
};
</script>
<style>
</style>
